import { EntityType } from '../../../@types/entityTypes';
import workspaceQuery from '../../queries/sales/DispatchInstructionLinesWorkspaceQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const DispatchInstructionLine: EntityType = {
  type: 'DispatchInstructionLine',
  title: 'Dispatch Instruction Lines',
  workspaceUrl: '/Sales/DispatchInstructionLines/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'DISPATCH_INSTRUCTION_LINES',
  operations: ALLOW_VIEW,
};

export default DispatchInstructionLine;
